import {
  Alert,
  Autocomplete,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewNotification,
  fetchNotificationList,
  fetchEditNotification,
} from "../actions/notification";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Editor } from "ckeditor5-custom-build/build/ckeditor";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import InputField from "../components/Admin/Reusable/InputField";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchCustomFormExtendedList } from "../actions/customer";
import { fetchCompanyFormList } from "../actions/company";
import { fetchStoreFormExtendedList } from "../actions/store";
import CloseIcon from "@mui/icons-material/Close";
import { Label } from "@mui/icons-material";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { sr } from "date-fns/locale"; // ili sr, hr, sl, itd.

const NotificationAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  //breadcrumb
  const translateForm = "notificationsForm";
  const translateModule = "notifications";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [dataForm, setDataForm] = useState({
    companyList: [],
    storeList: [],
    accountList: [],
  });

  const handleAddToFormTable = () => {
    if (selectedCompany) {
      // Proveri da li kompanija već postoji u companyList
      const isCompanyExists = dataForm.companyList.some(
        (company) => company.id === selectedCompany.id
      );

      if (!isCompanyExists) {
        setDataForm((prevState) => ({
          ...prevState,
          companyList: [...prevState.companyList, selectedCompany],
        }));
        setSelectedCompany(null);
      } else {
        toast.error("Ova kompanija je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableStore = () => {
    if (selectedStore) {
      // Proveri da li radnja već postoji u storeList
      const isStoreExists = dataForm.storeList.some(
        (store) => store.id === selectedStore.id
      );

      if (!isStoreExists) {
        setDataForm((prevState) => ({
          ...prevState,
          storeList: [...prevState.storeList, selectedStore],
        }));
        setSelectedStore(null);
      } else {
        toast.error("Ova radnja je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleAddToFormTableAccount = () => {
    if (selectedAccount) {
      const isAccountExists = dataForm.accountList.some(
        (account) => account.id === selectedAccount.id
      );

      if (!isAccountExists) {
        setDataForm((prevState) => ({
          ...prevState,
          accountList: [...prevState.accountList, selectedAccount],
        }));
        setSelectedAccount(null);
      } else {
        toast.error("Ovaj korisnik je već dodata!", { theme: "colored" });
      }
    }
  };

  const handleRemoveFromFormTable = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      companyList: prevState.companyList.filter((company) => company.id !== id),
    }));
  };
  const handleRemoveFromFormTableStore = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      storeList: prevState.storeList.filter((store) => store.id !== id),
    }));
  };
  const handleRemoveFromFormTableAccount = (id) => {
    setDataForm((prevState) => ({
      ...prevState,
      accountList: prevState.accountList.filter((account) => account.id !== id),
    }));
  };

  const initialState = {
    title: "",
    countryId: "",
    body: "",
    type: "", //MAIL,APP,BOTH
    deliveryTime: "",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const { notificationDetail } = useSelector(
    (state) => state.notificationReducer
  );

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { companyFormList } = useSelector((state) => state.companyReducer);
  const { customerExtendedFormList } = useSelector(
    (state) => state.customerReducer
  );
  const { storeFormExtendedList } = useSelector((state) => state.storeReducer);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleInputChangeCountry = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    dispatch(fetchStoreFormExtendedList(e.target.value));
    dispatch(fetchCustomFormExtendedList(e.target.value));
    dispatch(fetchCompanyFormList(e.target.value));
  };

  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
      setDataForm({
        companyList: [],
        storeList: [],
        accountList: [],
      });
    } else {
      // Ako `id` postoji, učitaj podatke za promociju
      dispatch(fetchNotificationList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (notificationDetail) {
      setData({
        ...data,
        title: notificationDetail.title || "",
        countryId: notificationDetail.countryId || "",
        body: notificationDetail.body || "",
        type: notificationDetail.type || "",
        deliveryTime: notificationDetail.deliveryTime || "",
        createdAt: notificationDetail.createdAt || "",
        updatedAt: notificationDetail.updatedAt || "",
        accounts: notificationDetail.accounts || "",
        companies: notificationDetail.companies || "",
        stores: notificationDetail.stores || "",
      });

      if (notificationDetail.countryId) {
        dispatch(fetchStoreFormExtendedList(notificationDetail.countryId));
        dispatch(fetchCustomFormExtendedList(notificationDetail.countryId));
        dispatch(fetchCompanyFormList(notificationDetail.countryId));
      }
    }
  }, [notificationDetail, dispatch]);

  useEffect(() => {
    if (countryFormList?.length == 1) {
      setData((prevData) => ({
        ...prevData,
        countryId: countryFormList[0].id,
      }));
      dispatch(fetchStoreFormExtendedList(countryFormList[0].id));
      dispatch(fetchCustomFormExtendedList(countryFormList[0].id));
      dispatch(fetchCompanyFormList(countryFormList[0].id));
    }
  }, [countryFormList]);

  useEffect(() => {
    if (companyFormList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedCompanies = companyFormList.filter((company) =>
        data?.companies?.includes(company.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        companyList: selectedCompanies,
      }));
    }
  }, [companyFormList]);

  useEffect(() => {
    if (storeFormExtendedList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedStores = storeFormExtendedList.filter((store) =>
        data?.stores?.includes(store.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        storeList: selectedStores,
      }));
    }
  }, [storeFormExtendedList]);

  useEffect(() => {
    if (customerExtendedFormList.length > 0 && id) {
      //pronalazim selektovane kompanije
      const selectedAccount = customerExtendedFormList.filter((product) =>
        data?.accounts?.some((item) => item === product.id)
      );
      //setujem selektovane kompanije
      setDataForm((prevState) => ({
        ...prevState,
        accountList: selectedAccount,
      }));
    }
  }, [customerExtendedFormList]);

  const clientValidationHandler = () => {
    const { title, body, type, countryId } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      title,
      body,
      type,
      countryId,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (clientValidationHandler()) {
      return;
    }

    const items = {
      stores: dataForm.storeList.map((store) => store.id),
      companies: dataForm.companyList.map((company) => company.id),
      accounts: dataForm.accountList.map((account) => account.id),
      title: data.title,
      body: data.body,
      type: data.type,
      deliveryTime: data.deliveryTime,
      countryId: data.countryId,
    };

    if (id) {
      items.id = id;
      dispatch(fetchEditNotification(items, navigate));
    } else {
      dispatch(createNewNotification(items, navigate));
    }
  };

  const handleCopyToClipboard = (text) => {
    // Kopiranje u clipboard
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Kopirano u clipboard", { theme: "colored" });
      })
      .catch((error) => {
        toast.error("Greska pri kopiranju u clipboard", { theme: "colored" });
      });
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        pageType={pageType}
        extraTitle={notificationDetail && notificationDetail.name}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={12}>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>
                          <FormTitleMain />
                        </Card.Header>
                        <Card.Body>
                          <div className="notification-holder-admin-left-side-text">
                            <Row>
                              <Col lg={12} md={12} xs={12}>
                                <Alert severity="info" className="mb-3">
                                  {t("notificationAddForm.deliveryTimeAlert")}
                                </Alert>
                              </Col>
                              <Col lg={6} md={12} xs={12} className="mb-4">
                                <InputField
                                  label={t("notificationAddForm.title")}
                                  name="title"
                                  value={data?.title}
                                  onChange={handleInputChange}
                                  error={errors}
                                  errorsHandler={setErrors}
                                  fullWidth
                                  size="small"
                                  required
                                  disabled={id}
                                />
                              </Col>

                              <Col lg={3} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.countryId ? true : false}
                                  disabled={id || countryFormList?.length === 1}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("notificationAddForm.country")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.countryId}
                                    label={t("notificationAddForm.country")}
                                    name="countryId"
                                    onChange={handleInputChangeCountry}
                                    size="small"
                                  >
                                    {countryFormList?.map((item, key) => (
                                      <MenuItem value={item.id} key={key}>
                                        {item.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {errors?.countryId && (
                                    <FormHelperText>
                                      {t("notificationAddForm.requiredField")}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>

                              <Col lg={3} md={12} xs={12} className="mb-3">
                                <FormControl
                                  fullWidth
                                  required
                                  size="small"
                                  error={errors?.type ? true : false}
                                  disabled={id}
                                >
                                  <InputLabel id="demo-simple-select-label">
                                    {t("notificationAddForm.type")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={data?.type}
                                    label={t("notificationAddForm.type")}
                                    name="type"
                                    onChange={handleInputChange}
                                    size="small"
                                  >
                                    <MenuItem value="APP">
                                      {t("notificationAddForm.appType")}
                                    </MenuItem>
                                    <MenuItem value="MAIL">
                                      {t("notificationAddForm.mailType")}
                                    </MenuItem>
                                    <MenuItem value="BOTH">
                                      {t("notificationAddForm.bothType")}
                                    </MenuItem>
                                  </Select>
                                  {errors?.type && (
                                    <FormHelperText>
                                      {t("notificationAddForm.requiredField")}
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Col>

                              <Col lg={3} md={12} xs={12} className="mb-4">
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  adapterLocale={sr}
                                >
                                  <DateTimePicker
                                    label={t(
                                      "notificationAddForm.deliveryTime"
                                    )}
                                    value={data?.deliveryTime || null}
                                    onChange={(newValue) => {
                                      setData((prev) => ({
                                        ...prev,
                                        deliveryTime: newValue,
                                      }));
                                    }}
                                    minutesStep={30} // 👈 OVO je ključno
                                    disabled={id}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        error={!!errors?.deliveryTime}
                                        helperText={errors?.deliveryTime}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Col>

                              <Col lg={12} md={12} xs={12} className="mb-2">
                                <h6 id="demo-simple-select-label">
                                  {t("notificationAddForm.bodyContent")}
                                </h6>
                                <div className="tag-items-mail-body">
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.name")}
                                      onClick={() =>
                                        handleCopyToClipboard("%name")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.lastName")}
                                      onClick={() =>
                                        handleCopyToClipboard("%lastName")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.email")}
                                      onClick={() =>
                                        handleCopyToClipboard("%email")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.phone")}
                                      onClick={() =>
                                        handleCopyToClipboard("%phone")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t(
                                        "notificationAddForm.companyName"
                                      )}
                                      onClick={() =>
                                        handleCopyToClipboard("%companyName")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.storeName")}
                                      onClick={() =>
                                        handleCopyToClipboard("%storeName")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.city")}
                                      onClick={() =>
                                        handleCopyToClipboard("%city")
                                      }
                                    />
                                  </div>
                                  <div className="tag-main-body-item">
                                    <Chip
                                      variant="outlined"
                                      label={t("notificationAddForm.address")}
                                      onClick={() =>
                                        handleCopyToClipboard("%adress")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="mail-body-editor">
                                  <div className="mail-body-editor-item">
                                    <CKEditor
                                      name="body"
                                      disabled={id}
                                      editor={Editor}
                                      data={data.body}
                                      onReady={(editor) => {}}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setData((prevData) => ({
                                          ...prevData,
                                          body: data,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                    {data.countryId && (
                      <Fragment>
                        <Fragment>
                          <Col lg={6}>
                            <Card>
                              <Card.Header>
                                {t(
                                  "notificationAddForm.companySelectionCardTitle"
                                )}
                              </Card.Header>
                              <Card.Body>
                                <Row>
                                  <Col lg={12}>
                                    {!id && (
                                      <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                        <Autocomplete
                                          options={companyFormList}
                                          getOptionLabel={(option) =>
                                            option.name
                                          }
                                          fullWidth
                                          value={selectedCompany}
                                          onChange={(e, newValue) => {
                                            setSelectedCompany(newValue);
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={t(
                                                "notificationAddForm.company"
                                              )}
                                              size="small"
                                            />
                                          )}
                                        />
                                        <Button
                                          variant="contained"
                                          onClick={handleAddToFormTable}
                                          startIcon={<AddIcon />}
                                        >
                                          {t("notificationAddForm.buttonAdd")}
                                        </Button>
                                      </div>
                                    )}
                                    {dataForm?.companyList?.length > 0 ? (
                                      <Table
                                        bordered
                                        hover
                                        size="sm"
                                        responsive="sm"
                                        striped
                                        className="mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th className="text-center text-bold">
                                              {t(
                                                "notificationAddForm.companyTableColumn"
                                              )}
                                            </th>
                                            {!id && (
                                              <th
                                                className="text-center"
                                                width="1%"
                                              ></th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {dataForm?.companyList?.map(
                                            (item, key) => (
                                              <tr key={key}>
                                                <td>{item.name}</td>
                                                {!id && (
                                                  <td className="text-center">
                                                    <CloseIcon
                                                      sx={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        handleRemoveFromFormTable(
                                                          item.id
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                )}
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    ) : (
                                      <Alert severity="info">
                                        {t(
                                          "notificationAddForm.infoNoSelectedCompany"
                                        )}
                                      </Alert>
                                    )}
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Col>
                          <Col lg={6}>
                            <Card>
                              <Card.Header>
                                {t(
                                  "notificationAddForm.storeSelectionCardTitle"
                                )}
                              </Card.Header>
                              <Card.Body>
                                <Row>
                                  <Col lg={12}>
                                    {!id && (
                                      <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                        <Autocomplete
                                          options={storeFormExtendedList}
                                          getOptionLabel={(option) =>
                                            option.name
                                          }
                                          fullWidth
                                          value={selectedStore}
                                          onChange={(e, newValue) => {
                                            setSelectedStore(newValue);
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={t(
                                                "notificationAddForm.store"
                                              )}
                                              size="small"
                                            />
                                          )}
                                        />
                                        <Button
                                          variant="contained"
                                          onClick={handleAddToFormTableStore}
                                          startIcon={<AddIcon />}
                                        >
                                          {t("notificationAddForm.buttonAdd")}
                                        </Button>
                                      </div>
                                    )}
                                    {dataForm?.storeList?.length > 0 ? (
                                      <Table
                                        bordered
                                        hover
                                        size="sm"
                                        responsive="sm"
                                        striped
                                        className="mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th className="text-center text-bold">
                                              {t(
                                                "notificationAddForm.storeTableColumn"
                                              )}
                                            </th>
                                            <th className="text-center text-bold">
                                              {t(
                                                "notificationAddForm.companyTableColumn"
                                              )}
                                            </th>
                                            {!id && (
                                              <th
                                                className="text-center"
                                                width="1%"
                                              ></th>
                                            )}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {dataForm?.storeList?.map(
                                            (item, key) => (
                                              <tr key={key}>
                                                <td>{item.name}</td>
                                                <td>{item.companyName}</td>
                                                {!id && (
                                                  <td className="text-center">
                                                    <CloseIcon
                                                      sx={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        handleRemoveFromFormTableStore(
                                                          item.id
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                )}
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    ) : (
                                      <Alert severity="info">
                                        {t(
                                          "notificationAddForm.infoNoSelectedStore"
                                        )}
                                      </Alert>
                                    )}
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Fragment>
                        <Col lg={12}>
                          <Card>
                            <Card.Header>
                              {t("notificationAddForm.userSelectionCardTitle")}
                            </Card.Header>
                            <Card.Body>
                              <Row>
                                <Col lg={12}>
                                  {!id && (
                                    <div className="form-input-add-holder d-flex gap-2 justify-content-between align-items-center mb-3">
                                      <Autocomplete
                                        options={customerExtendedFormList}
                                        getOptionLabel={(option) =>
                                          `${option.name} ${option.lastName} (${
                                            option.companyName
                                          } / ${option.storeName} / ${t(
                                            `global.${option.sector}`
                                          )})`
                                        }
                                        fullWidth
                                        value={selectedAccount}
                                        onChange={(e, newValue) => {
                                          setSelectedAccount(newValue);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label={t(
                                              "notificationAddForm.user"
                                            )}
                                            size="small"
                                          />
                                        )}
                                      />
                                      <Button
                                        variant="contained"
                                        onClick={handleAddToFormTableAccount}
                                        startIcon={<AddIcon />}
                                      >
                                        {t("notificationAddForm.buttonAdd")}
                                      </Button>
                                    </div>
                                  )}
                                  {dataForm?.accountList?.length > 0 ? (
                                    <Table
                                      bordered
                                      hover
                                      size="sm"
                                      responsive="sm"
                                      striped
                                      className="mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-center text-bold">
                                            {t(
                                              "notificationAddForm.userTableColumn"
                                            )}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t(
                                              "notificationAddForm.companyTableColumn"
                                            )}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t(
                                              "notificationAddForm.storeTableColumn"
                                            )}
                                          </th>
                                          <th className="text-center text-bold">
                                            {t(
                                              "notificationAddForm.sectorName"
                                            )}
                                          </th>
                                          {!id && (
                                            <th
                                              className="text-center"
                                              width="1%"
                                            ></th>
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {dataForm?.accountList?.map(
                                          (item, key) => (
                                            <tr key={key}>
                                              <td>
                                                {item.name} {item.lastName}
                                              </td>
                                              <td>{item.companyName}</td>
                                              <td>{item.storeName}</td>
                                              <td>
                                                {t(`global.${item.sector}`)}
                                              </td>
                                              {!id && (
                                                <td className="text-center">
                                                  <CloseIcon
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={() =>
                                                      handleRemoveFromFormTableAccount(
                                                        item.id
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  ) : (
                                    <Alert severity="info">
                                      {t(
                                        "notificationAddForm.infoNoSelectedUser"
                                      )}
                                    </Alert>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Fragment>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default NotificationAdd;
